import { trackEvent } from '../tools'

/**
 * 上下架筛选次数
 * app_source:1商家端手机端；2BD App
 * 筛选项status：0全部；1上架；2下架
 */
export function itemStatusFilterClick(trackParams = {}) {
  trackEvent({
    eventId: 'sailing_b_web_item_status_filter_ck',
    eventLabel: '上下架筛选次数',
    attrs: trackParams,
  })
}
/**
 * 列表图片问题筛选次数
 * app_source:1商家端手机端；2BD App
 * 筛选项status：0默认；1无图；2重图
 */
export function itemProblemFilterClick(trackParams = {}) {
  trackEvent({
    eventId: 'sailing_b_web_pic_issue_filter_ck',
    eventLabel: '列表图片问题筛选次数',
    attrs: trackParams,
  })
}

// 菜品异常操作弹窗曝光
export function hotSaleItemPopSw(attrs) {
  trackEvent({
    eventId: 'sailing_b_m_item_abnormal_operation_popup_sw',
    eventLabel: '菜品异常操作弹窗曝光',
    attrs,
  })
}
// 菜品异常操作点击
export function hotSaleItemPopSubmit(attrs) {
  trackEvent({
    eventId: 'sailing_b_m_item_abnormal_operation_popup_ck',
    eventLabel: '菜品异常操作点击',
    attrs,
  })
}

export function itemUpAndDownClick(attrs) {
  trackEvent({
    eventId: 'sailing_b_x_item_upanddown_ck',
    eventLabel: '菜品上下架点击',
    attrs,
  })
}

export function itemSearchClick(attrs) {
  trackEvent({
    eventId: 'sailing_b_x_item_search_ck',
    eventLabel: '菜品搜索点击',
    attrs,
  })
}

/**
 *
 * app菜品供应列表页面曝光的PV和UV
 * done
 */
export function itemListSw(trackParams = {}) {
  trackEvent({
    eventId: 'sailing_b_app_item_list_sw',
    eventLabel: 'app菜品供应列表页面曝光',
    attrs: trackParams,
  })
}

/**
 *
 * app菜品供应列表主菜上下架点击的次数
 * done
 */
export function itemlistItemTurnlineCk(trackParams = {}) {
  trackEvent({
    eventId: 'sailing_b_app_itemlist_item_turnline_ck',
    eventLabel: 'app菜品供应列表主菜上下架点击',
    attrs: trackParams,
  })
}

/**
 *
 * app菜品供应列表子菜上下架点击的次数
 * done
 */
export function itemlistSubitemTurnlineCk(trackParams = {}) {
  trackEvent({
    eventId: 'sailing_b_app_itemlist_subitem_turnline_ck',
    eventLabel: 'app菜品供应列表子菜上下架点击',
    attrs: trackParams,
  })
}

/**
 *
 * app菜品供应列表同名菜品下架的使用次数
 * done
 */
export function itemlistMarkSameNameAvailableCk(trackParams = {}) {
  trackEvent({
    eventId: 'sailing_b_app_itemlist_mark_same_name_available_ck',
    eventLabel: 'app菜品供应列表同名菜品下架点击',
    attrs: trackParams,
  })
}

/**
 *
 * app菜品供应列表菜品类型切换筛选的次数
 * done
 */
export function itemlistItemStatusSelectCk(trackParams = {}) {
  trackEvent({
    eventId: 'sailing_b_app_itemlist_item_status_select_ck',
    eventLabel: 'app菜品供应列表菜品类型切换点击',
    attrs: trackParams,
  })
}

/**
 *
 * app菜品供应列表搜索次数
 * done
 */
export function itemlistSearchCk(trackParams = {}) {
  trackEvent({
    eventId: 'sailing_b_app_itemlist_search_ck',
    eventLabel: 'app菜品供应列表搜索次数',
    attrs: trackParams,
  })
}

/**
 *
 * app菜品供应列表搜索有结果的次数
 * done
 */
export function itemlistSearchResultSw(trackParams = {}) {
  trackEvent({
    eventId: 'sailing_b_app_itemlist_search_result_sw',
    eventLabel: 'app菜品供应列表搜索有结果曝光',
    attrs: trackParams,
  })
}

/**
 *
 * app菜品供应列表搜索结果主菜上下架点击次数
 * done
 */
export function itemlistSearchItemTurnlineCk(trackParams = {}) {
  trackEvent({
    eventId: 'sailing_b_app_itemlist_search_item_turnline_ck',
    eventLabel: 'app菜品供应列表搜索结果主菜上下架点击',
    attrs: trackParams,
  })
}

/**
 *
 * app菜品供应列表搜索结果子菜上下架点击次数
 * done
 */
export function itemlistSearchSubitemTurnlineCk(trackParams = {}) {
  trackEvent({
    eventId: 'sailing_b_app_itemlist_search_subitem_turnline_ck',
    eventLabel: 'app菜品供应列表搜索结果子菜上下架点击',
    attrs: trackParams,
  })
}
/**
 * 检测结果通知商家展现
 * @params message_type 1(高价菜禁售) 2(提价失败)
 */
export function itemCheckNotificationSw(trackParams = {}) {
  trackEvent({
    eventId: 'sailing_b_m_item_check_notification_sw',
    eventLabel: '检测结果通知商家展现',
    attrs: {
      ...trackParams,
    },
  })
}

export function itemPutOffSaleClick(trackParams = {}) {
  trackEvent({
    eventId: 'sailing_b_x_item_down_popup_sw',
    eventLabel: '门店端下架菜品弹窗曝光',
    attrs: trackParams,
  })
}
